import type { EffectDefinition, EffectContext } from './types'

interface RainDrop {
  x: number
  y: number
  speed: number
  length: number
  opacity: number
}

function createDrop(width: number, height: number): RainDrop {
  return {
    x: Math.random() * width,
    y: Math.random() * height * -1,
    speed: 400 + Math.random() * 300,
    length: 15 + Math.random() * 20,
    opacity: 0.15 + Math.random() * 0.25
  }
}

export const rain: EffectDefinition = {
  id: 'rain',
  name: 'Rain',

  init(ctx: EffectContext) {
    const count = Math.floor((ctx.width * ctx.height) / 3000)
    const drops: RainDrop[] = []
    for (let i = 0; i < count; i++) {
      const drop = createDrop(ctx.width, ctx.height)
      drop.y = Math.random() * ctx.height
      drops.push(drop)
    }
    return drops
  },

  update(state: unknown, ctx: EffectContext) {
    const drops = state as RainDrop[]
    const dt = ctx.deltaTime / 1000
    for (const drop of drops) {
      drop.y += drop.speed * dt
      drop.x += 30 * dt
      if (drop.y > ctx.height + drop.length) {
        drop.y = -drop.length
        drop.x = Math.random() * ctx.width
      }
    }
  },

  draw(state: unknown, ctx: EffectContext) {
    const drops = state as RainDrop[]
    const { ctx: c } = ctx
    for (const drop of drops) {
      c.beginPath()
      c.moveTo(drop.x, drop.y)
      c.lineTo(drop.x + 2, drop.y + drop.length)
      c.strokeStyle = `rgba(180, 210, 255, ${drop.opacity})`
      c.lineWidth = 1
      c.stroke()
    }
  }
}
